import { render, staticRenderFns } from "./SwapPool.vue?vue&type=template&id=3625a824&scoped=true"
import script from "./SwapPool.js?vue&type=script&lang=js&external"
export * from "./SwapPool.js?vue&type=script&lang=js&external"
import style0 from "./SwapPool.vue?vue&type=style&index=0&id=3625a824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625a824",
  null
  
)

export default component.exports